// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__NhkKU","rowContainer":"Footer_rowContainer__4xL2X","rightBlock":"Footer_rightBlock__hdCC4"};